import React from 'react'

// import moment from 'moment'
// import { v4 as uuid } from 'uuid'
// @material-ui/core
import { makeStyles } from '@material-ui/core/styles'
import Backdrop from '@material-ui/core/Backdrop'
import CircularProgress from '@material-ui/core/CircularProgress'
import Snackbar from '@material-ui/core/Snackbar'
import Slide from '@material-ui/core/Slide'

// @material-ui/icons
import Store from '@material-ui/icons/Store'

// core components
import GridItem from '../../components/Grid/GridItem.js'
import GridContainer from '../../components/Grid/GridContainer.js'
import Card from '../../components/Card/Card.js'
import CardHeader from '../../components/Card/CardHeader.js'
import CardIcon from '../../components/Card/CardIcon.js'
import CardFooter from '../../components/Card/CardFooter.js'
import AtlasModal from '../../components/AtlasModal/AtlasModal.js'
import Button from 'components/CustomButtons/Button.js'

// Dashboard views
import OrganisationView from './DashboardView/OrgView.js'

import styles from '../../assets/jss/material-dashboard-pro-react/views/dashboardStyle.js'

import {
  priceChangeData
} from './MockData/MockDashboardData.js'

// Get data using aws amplify
import {
  dashboardResponse,
  registerSitesResponse,
  siteSummary
} from '../../layouts/Aws.js'

function SlideTransition (props) {
  return <Slide {...props} direction="down" />
}

const useStyles = makeStyles(styles)

export default function Dashboard () {
  const classes = useStyles()
  const [orgSummary, setOrgSummary] = React.useState({})
  const [openLoading, setOpenLoading] = React.useState(true)
  const [showContent, setShowContent] = React.useState(classes.divHidden)
  const [modalOpen, setModalOpen] = React.useState(false)
  const [error, setError] = React.useState(false)
  const [snackbarOpen, setSnackbarOpen] = React.useState(true)

  // Mock data
  const [mockPriceChanges, setMockPriceChanges] = React.useState()

  React.useEffect(() => {
    getDashboardResponse()

    const mockPriceChangeData = priceChangeData()

    setMockPriceChanges(mockPriceChangeData)
  }, [])

  React.useEffect(() => {
  }, [orgSummary])

  const formData = {
    ShopID: {
      value: '',
      validator: /^[0-9\b]{4}$/,
      placeholderText: 'Shop ID'
    },
    PostCode: {
      value: '',
      validator: /^[A-Za-z]{1,2}\d[A-Za-z\d]?\s*\d[A-Za-z]{2}$/,
      placeholderText: 'Post Code'
    },
    Email: {
      value: '',
      validator: /^[a-zA-Z0-9.!#$%&'*+/=?^_`{|}~-]+@[a-zA-Z0-9](?:[a-zA-Z0-9-]{0,61}[a-zA-Z0-9])?(?:\.[a-zA-Z0-9](?:[a-zA-Z0-9-]{0,61}[a-zA-Z0-9])?)*$/,
      placeholderText: 'Registered Email'
    }
  }

  const registerSite = async (data) => {
    const bodyData = {
      payload: {
        shopID: data.ShopID.value,
        postCode: data.PostCode.value,
        email: data.Email.value
      }
    }

    const response = await registerSitesResponse(bodyData)

    return response
  }

  const getDashboardResponse = () => {
    dashboardResponse().then(async (res) => {
      if (res !== undefined) {
        if (res.errorType === 'Error') {
          setOrgSummary({})
          setOpenLoading(false)
          setShowContent(classes.divShown)
        } else {
          // Pre-set the org summary top level values
          res.noSales = 0
          res.cancelled = 0
          res.voids = 0
          res.discounts = 0

          for (let i = 0; i < res.sites.length; ++i) {
            // res.sites[i].status = i % 2 === 0 ? 1 : 0

            // Pre-set the org summary top level values
            res.sites[i].transactions = 0
            res.sites[i].grossSales = 0

            // Set the number of users
            res.sites[i].users = Math.floor(Math.random() * 4) + 1

            // Set if we have opened up the accordion
            res.sites[i].isOpen = false

            // sales data
            res.sites[i].salesData = []

            // today and yesterday
            res.sites[i].salesData.today = []
            res.sites[i].salesData.yesterday = []

            // labels
            res.sites[i].salesData.today.labels = []
            res.sites[i].salesData.yesterday.labels = []

            res.sites[i].salesData.chartData = {}
          }

          // We then want to call the site summary API
          // And populate our object backwards
          await siteSummary({}).then(async (summaryRes) => {
            if (summaryRes.errorType !== undefined) {
              setError(true)
            } else {
              if (Object.keys(res).length !== 0) {
                res.cancelled = checkDefinedValue(summaryRes.cancelled)
                res.discounts = checkDefinedValue(summaryRes.discounts)
                res.noSales = checkDefinedValue(summaryRes.noSales)
                res.transactions = checkDefinedValue(summaryRes.transactions)
                res.voids = checkDefinedValue(summaryRes.voids)

                if (summaryRes.sites !== undefined) {
                  // Check each key within the site summary
                  for (const [key, value1] of Object.entries(summaryRes.sites)) {
                    // Go throught the sites we have obtained from
                    // the dashboard summary API call
                    res.sites.forEach(site => {
                      // If the site ID matches with a key
                      // we will populate the data for this site

                      if (site.id === key) {
                        for (const [key, value2] of Object.entries(value1)) {
                          switch (key) {
                            case 'noSales':
                              site.noSales = value2
                              break
                            case 'cancelled':
                              site.cancelled = value2
                              break
                            case 'voids':
                              site.voids = value2
                              break
                            case 'discounts':
                              site.discounts = value2
                              break
                            case 'grossSales':
                              site.grossSales = value2
                              break
                            case 'transactions':
                              site.transactions = value2
                              break
                          }
                        }
                      }
                    })
                  }
                }
              }
            }

            setOrgSummary(res)
            setOpenLoading(false)
          })
        }
      }
    })
  }

  const checkDefinedValue = (value) => {
    if (value !== undefined) {
      return value
    } else {
      return 0
    }
  }

  const openModal = () => {
    setModalOpen(true)
  }

  const closeModal = () => {
    setModalOpen(false)
  }

  const backdropComponent = () => {
    return <>
      <Backdrop className={classes.backdrop} open={true}>
        <CircularProgress className={classes.backdropSpinner}/>
      </Backdrop> </>
  }

  // Our component for the registration of a new site
  const newSiteRegisterComponent = () => {
    return <div className={showContent}>
      <GridItem xs={12}>
        <Card>
          <CardHeader icon>
            <div className={classes.centered}>
              <CardIcon color="danger">
                <Store />
              </CardIcon>
            </div>
            <div className={classes.centered}>
              <div>
                <h3 style={{ color: 'black' }}><b>No sites associated with this account</b></h3>
              </div>
            </div>
          </CardHeader>
          <CardIcon>
            <div className={classes.centered} style={{ marginLeft: '10%', marginRight: '10%' }}>
              <p>
          Click below to register your
                <strong> ShopMate </strong>
          site(s) to your account
              </p>
            </div>
            <br/>
            <div className={classes.centered}>
              <Button variant="outlined" color="primary" onClick={openModal}>
        Click here to setup
              </Button>
            </div>
            <div className={classes.centered}>
              <AtlasModal
                title='Enter your site details below'
                modalOpen={modalOpen}
                useBtnClose={false}
                dialogContentType='form'
                dialogFormProps={formData}
                dialogFormOnSubmit={registerSite}
                callback={getDashboardResponse}
                onClose={closeModal}/>
            </div>
          </CardIcon>
          <CardFooter>
          </CardFooter>
        </Card>
      </GridItem>
    </div>
  }

  // Our components for the main area of the dashboard
  const siteListComponent = () => {
    return (orgSummary.sites && orgSummary.sites.length > 0
      ? <>
        {error ? <Snackbar
          open={snackbarOpen}
          TransitionComponent={SlideTransition}
          message="An error occurred, please try refreshing the page"
          key={'error-snackbar'}
          anchorOrigin={{ vertical: 'top', horizontal: 'center' }}
          transitionDuration={1000}
          onClose={(event, reason) => {
            if (reason === 'clickaway') {
              setSnackbarOpen(false)
            }
          }}
        /> : null}
        <OrganisationView
          orgSummary={orgSummary}
          mockPriceChanges={mockPriceChanges}/>
      </> : newSiteRegisterComponent()
    )
  }

  return (<GridContainer>
    { openLoading
      ? backdropComponent()
      : siteListComponent()
    }
  </GridContainer>
  )
}
